

<template>
    <div :class="['game-history', this.player ? 'game-history-'+this.player: '', side ? 'side-'+side : '']" v-if="loaded">
        <div class="game-history-headers">
            <div class="game-history-col">{{__('games.round')}}</div>
            <div :class="['game-history-col', header.main ? 'game-history-col-main':'']" v-for="header in headers" :key="header.name">{{__(header.name)}}</div>
        </div>
        <div class="game-history-round" v-for="round, idx in history" :key="idx" @click="openChangePopup(round)">
            <div class="game-history-col game-history-col-content">{{idx + offset + 1}}</div>
            <div class="game-history-col game-history-col-content" v-for="header in headers" :key="header.name">
                <template v-if="header.value && round[playerIndex]">
                    <span class="singlescores" v-if="header.value == 'singlescores' && round[playerIndex].singlescores && round[playerIndex].singlescores.length > 0">
                        <span class="singlescore" v-if="round[playerIndex].singlescores[0]">{{round[playerIndex].singlescores[0].str}}</span>
                        <span class="singlescore" v-if="round[playerIndex].singlescores[1]">{{round[playerIndex].singlescores[1].str}}</span>
                        <span class="singlescore" v-if="round[playerIndex].singlescores[2]">{{round[playerIndex].singlescores[2].str}}</span>
                    </span>
                    <span v-else-if="header.value !== 'singlescores'">{{round[playerIndex][header.value]}}</span>
                </template>
            </div>
        </div>
        <b-modal id="modal-change-popup" title="Change Throw" @hidden="closeChangePopup" v-if="changePopupOpen && roundToChange">
            <template #default>
                <h1>Rundenscore &auml;ndern</h1>
                <label for="alt">Alt</label>
                <input type="text" v-model="roundToChange[0].fullscore">
                <label for="neu">Neu</label>
                <input type="text" v-model="roundToChange[0].newscore"/>
            </template>
            <template #modal-footer>
                <input type="submit" value="Aenderng speichern" @click="changeScore()"/>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['player', 'side'],
    data() {
        return {
            players: null,
            playerIndex: null,
            history: [],
            headers: [],
            loaded: false,
            offset: 0,
            changePopupOpen: false,
            roundToChange: null,
        }
    },
    mounted() {
        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);
    },
    methods: {
        update(data) {
            if (data == null) return;
            this.playerIndex = data.gameState.currentPlayerIndex;
            if (this.player) this.playerIndex = this.player;
            if (this.players == null) {
                this.players = data.players;
            }
            this.history = data.gameState.history;
            if (this.history[1])
                this.playerIndex = this.offsetHistoryData(this.history[1], this.playerIndex);
            //max 8 rows, use last rows
            this.offset = this.history.length - 9;
            if (this.offset < 0) this.offset = 0;
            this.history = this.history.slice(1).slice(-8);
            if (this.history.length < 8) {
                for (let i = this.history.length; i < 8; i++) {
                    this.history[i] = [];
                }
            }
            this.headers = data.gameState.historyHeaders;
            this.loaded = true;
        },
        offsetHistoryData(order, idx) {
            //get playersids
            var ids = [];
            order.forEach(element => {
                ids.push(element['player_id']);
            });
            var returnIndex = -1;
            var searchId = this.players[idx]['player_id'];
            ids.forEach((id, idx2) => {
                if (searchId == id) returnIndex = idx2;
            });
            return returnIndex;
        },
        changeScore() {
            console.log(this.roundToChange)
            this.closeChangePopup();
        },
        openChangePopup(round) {
            return;
            this.changePopupOpen = true;
            this.roundToChange = round;
            setTimeout(() => {
                this.$bvModal.show('modal-change-popup');
            }, 250);
        },
        closeChangePopup() {
            this.changePopupOpen = false;
            this.roundToChange = null;
            setTimeout(() => {
                this.$bvModal.hide('modal-change-popup');
            }, 250);
        }
    }
}
</script>
